import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { legalDocs } from '../data/legal';

const LegalPage = ({ docKey }) => {
  const doc = legalDocs[docKey];
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  if (!doc) return null;

  return (
    <div className="min-h-screen bg-white" data-testid={`legal-page-${docKey}`}>
      <Helmet defer={false}>
        <title>{`${doc.title} | LYNKO`}</title>
        <meta name="description" content={doc.metaDescription} />
        <link rel="canonical" href={`https://lynko.info/${docKey}`} />
      </Helmet>
      <Header />

      {/* Hero */}
      <section className="bg-gradient-to-r from-blue-600 to-blue-700 py-14 lg:py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-3xl lg:text-4xl font-bold text-white mb-3">{doc.title}</h1>
          <p className="text-blue-100 text-sm">{`Dernière mise à jour : ${doc.updated}`}</p>
        </div>
      </section>

      {/* Contenu */}
      <section className="py-12 lg:py-16 bg-gray-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6 lg:p-10 space-y-10">
            {doc.intro && (
              <div className="space-y-4">
                {doc.intro.map((p, i) => (
                  <p key={i} className="text-gray-700 leading-relaxed">{p}</p>
                ))}
              </div>
            )}
            {doc.sections.map((section, index) => (
              <div key={index} className="space-y-4" data-testid={`legal-section-${index + 1}`}>
                <h2 className="text-xl font-bold text-gray-900 pt-2 border-t border-gray-100 first:border-t-0">{section.heading}</h2>
                {section.paragraphs && section.paragraphs.map((p, i) => (
                  <p key={i} className="text-gray-700 leading-relaxed">{p}</p>
                ))}
                {section.list && (
                  <ul className="list-disc list-inside space-y-1.5 text-gray-700 leading-relaxed pl-2">
                    {section.list.map((item, i) => (
                      <li key={i}>{item}</li>
                    ))}
                  </ul>
                )}
                {section.afterList && section.afterList.map((p, i) => (
                  <p key={i} className="text-gray-700 leading-relaxed">{p}</p>
                ))}
                {section.subBlocks && section.subBlocks.map((sub, j) => (
                  <div key={j} className="space-y-3 pl-1">
                    <h3 className="font-semibold text-gray-900">{sub.title}</h3>
                    {sub.paragraphs && sub.paragraphs.map((p, i) => (
                      <p key={i} className="text-gray-700 leading-relaxed">{p}</p>
                    ))}
                    {sub.list && (
                      <ul className="list-disc list-inside space-y-1.5 text-gray-700 leading-relaxed pl-2">
                        {sub.list.map((item, i) => (
                          <li key={i}>{item}</li>
                        ))}
                      </ul>
                    )}
                    {sub.afterList && sub.afterList.map((p, i) => (
                      <p key={i} className="text-gray-700 leading-relaxed">{p}</p>
                    ))}
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default LegalPage;
